// iLive Chapters — header state + mobile drawer
// Phase 1: no hero yet, so on the homepage the sentinel sits at the top of <main>.
// Header starts solid; flips to transparent only if the sentinel is below the viewport.

(function () {
  const init = () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    if (header.dataset.headerInit === 'true') return;
    header.dataset.headerInit = 'true';

    const startsTransparent = header.dataset.transparentStart === 'true';

    // Find or create the sentinel just inside <main>.
    let sentinel = document.querySelector('[data-header-sentinel]');
    if (!sentinel) {
      const main = document.querySelector('main') || document.body;
      sentinel = document.createElement('div');
      sentinel.setAttribute('data-header-sentinel', '');
      sentinel.style.cssText = 'position:absolute;width:1px;height:1px;pointer-events:none;';
      main.prepend(sentinel);
    }

    const setState = (state) => {
      if (header.dataset.state !== state) header.dataset.state = state;
    };

    if (startsTransparent) {
      const io = new IntersectionObserver(([entry]) => {
        setState(entry.isIntersecting ? 'transparent' : 'solid');
      }, { rootMargin: '0px 0px -90% 0px' });
      io.observe(sentinel);
    } else {
      setState('solid');
    }

    // Mobile drawer
    const toggle = header.querySelector('[data-menu-toggle]');
    const drawer = header.querySelector('[data-mobile-nav]');
    if (toggle && drawer) {
      const onKey = (e) => {
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          const focusables = drawer.querySelectorAll('a, button');
          if (!focusables.length) return;
          const first = focusables[0];
          const last  = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) { last.focus();  e.preventDefault(); }
          else if (!e.shiftKey && document.activeElement === last)  { first.focus(); e.preventDefault(); }
        }
      };
      const open = () => {
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        const firstLink = drawer.querySelector('a');
        if (firstLink) firstLink.focus();
        document.addEventListener('keydown', onKey);
      };
      const close = () => {
        drawer.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
        document.removeEventListener('keydown', onKey);
        // Defer hidden=true until transition finishes so the slide-out animates.
        setTimeout(() => { drawer.hidden = true; }, 600);
      };
      toggle.addEventListener('click', () => {
        drawer.hasAttribute('hidden') ? open() : close();
      });
      // The open drawer covers the toggle on phones: close from its own button or a tap outside it.
      const isOpen = () => drawer.getAttribute('aria-hidden') === 'false';
      const closeBtn = drawer.querySelector('[data-mobile-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      // Capture phase + preventDefault: a tap on the dimmed page only closes the menu, never follows a link under it.
      document.addEventListener('click', (e) => {
        if (!isOpen() || drawer.contains(e.target) || toggle.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        close();
      }, true);
    }
  };

  // Run on first load and on every theme-editor section reload.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-header]')) {
      const header = e.target.querySelector('[data-header]');
      if (header) delete header.dataset.headerInit;
      init();
    }
  });
})();
